import React from 'react';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Dialog } from '@shared/components';
import WarningIcon from '@assets/icons/errorIcon.png';
import CloseWhiteIcon from '@assets/icons/cross-white.svg';
import classNames from 'classnames';
import './style.css';

// TODO: Refactor this and bulk upload to remove these default values
// from this component and pass it from bulk upload.
export default ({
  heading = 'Error',
  headingClassName = null,
  content = null,
  actionLabel = 'OK',
  errorKey,
  errorData,
  showModel,
  onClose,
  title = 'Oops! Conductor encountered an error. Please read the message below for details.',
  headers = null,
  errorBody = null,
  errorMessage = 'Duplicate data found',
  wrapperClassName = null,
  onCancel,
  actionLabelClass = null,
  titleBackground = 'bg-danger',
  hasCloseIcon = true,
  gridHeaderClass = '',
}) => {
  let gridBody = [];
  if (!headers) {
    headers = [`${errorKey}:`, 'Rows'];
  }

  if (errorData) {
    for (const key in errorData) {
      gridBody.push(
        <tr key={key}>
          <td className='pb-2 color-text-primary'>{key}</td>
          <td className='color-text-primary'>{errorData[key].join(', ')}</td>
        </tr>
      );
    }
  }

  if (errorBody) {
    errorBody.forEach((element, index) => {
      gridBody.push(
        <tr key={`${element} - ${index}`}>
          <td className='color-text-secondary'>{element}</td>
        </tr>
      );
    });
  }

  return (
    <Dialog
      className={classNames('error-modal-wrapper', wrapperClassName)}
      open={showModel}
      onClose={onCancel || onClose}
      centered
    >
      <Dialog.Title
        className={classNames('title', titleBackground)}
        closeIcon={CloseWhiteIcon}
        hasClose={hasCloseIcon}
      >
        <div className='align-center mb-1'>
          <img alt='' src={WarningIcon} />
        </div>
        <Typography
          variant='h5'
          className={clsx('medium-font', headingClassName)}
        >
          {heading}
        </Typography>
      </Dialog.Title>
      <Dialog.Content>
        <div className='content-wrapper txt'>
          {content ? (
            <>{content}</>
          ) : (
            <>
              <div className='into-txt color-text-secondary'>{title}</div>
              <div className='error-txt'>
                {errorMessage && (
                  <>
                    <span className='error-txt-color'>Error:</span>{' '}
                    <span className='color-text-primary'>{errorMessage}</span>
                  </>
                )}
              </div>
              <div className='grid-error-wrapper'>
                <table className='grid-error'>
                  <thead>
                    <tr className={clsx('color-text-primary', gridHeaderClass)}>
                      {headers.map(header => (
                        <th className='color-text-primary'>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className='color-text-secondary'>{gridBody}</tbody>
                </table>
              </div>
              {/* <div className='text-center'>
              <button className='btn btn-primary' onClick={onClose}>
                OK
              </button>
            </div> */}
            </>
          )}
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <div className='pr-5 pb-5'>
          <Button
            variant='contained'
            color='primary'
            onClick={onClose}
            className={actionLabelClass}
          >
            {actionLabel}
          </Button>
        </div>
      </Dialog.Actions>
    </Dialog>
  );
};
